import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

export default function Layout() {
  const navigate = useNavigate()

  // Check if logged in
  useEffect(() => {
    const checkLogin = async () => {
      const token = localStorage.getItem('Meteor.loginToken')
      if (!token) {
        const path = window.location.pathname
        if (path === '/login') return

        localStorage.setItem('nextPathname', path)
        console.log('going to login', path)
        navigate('/login')
      }
    }
    checkLogin()
  }, [navigate])

  return (
    <div className="dark">
      <Outlet />
    </div>
  )
}
